let env;

let {host, search} = location;

switch(true) {
  // Test if pre env first for `pre.xxx.taobao.com` like host
  case /(^|\.)(pre|wapa)\./.test(host):                                  // `pre.taobao.com` `wapp.wapa.taobao.com`
  case /(\?|&)pre=(1|true)(&|$)/.test(search):                           // `?pre=1` `&pre=true`
    env = 'pre';
    break;

  case /\.taobao\.com/.test(host):
  case /(\?|&)(production|online)=(1|true)(&|$)/.test(search):           // `?production=1` `&local=online`
    env = 'production';
    break;

  case /(^|\.)(daily|waptest)\./.test(host):                             // `login.daily.taobao.net` `wapp.waptest.taobao.com`
  case /(\?|&)daily=(1|true)(&|$)/.test(search):                         // `?daily=1` `&daily=true`
    env = 'daily';
    break;

  case /^localhost/.test(host):                                          // `localhost:8080`
  case /(^|\.)(debug|dev|development|local)\./.test(host):               // `local.taobao.net`
  case /(\d+\.){3}\d+/.test(host):                                       // `30.5.88.22`
  case /(\?|&)(debug|dev|development|local)=(1|true)(&|$)/.test(search): // `?development=1` `&local=true`
    env = 'development';
    break;

  default:
    env = 'production';
}

export default env;



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-env.js